import { MicrosoftReportProfileDelegate } from '../../../microsoft/profile/microsoft-report-profile-delegate';

export class SharePointReportProfileDelegate extends MicrosoftReportProfileDelegate {
}
